import { API_BASE } from '../config/api';

const handleResponse = async (response, fallbackMessage = 'Unable to load clubs.') => {
  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    const message = data.error || data.message || fallbackMessage;
    throw new Error(message);
  }

  return data;
};

export const fetchClubs = async () => {
  const response = await fetch(`${API_BASE}/api/clubs`);
  return handleResponse(response);
};

export const fetchClubsForAdmin = async (token) => {
  const response = await fetch(`${API_BASE}/api/clubs/manage`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return handleResponse(response);
};

export const fetchClubAdmins = async (token) => {
  const response = await fetch(`${API_BASE}/api/clubs/admins`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return handleResponse(response, 'Unable to load club admins.');
};

export const createClubAdmin = async (payload, token) => {
  const response = await fetch(`${API_BASE}/api/clubs/admins`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });

  return handleResponse(response, 'Unable to create club admin.');
};

export const createClub = async (payload, token) => {
  const response = await fetch(`${API_BASE}/api/clubs/manage`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });

  return handleResponse(response, 'Unable to create club.');
};

export const deleteClubAdmin = async (adminId, token) => {
  const response = await fetch(`${API_BASE}/api/clubs/admins/${adminId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return handleResponse(response, 'Unable to delete club admin.');
};

export const deleteClub = async (clubId, token) => {
  const response = await fetch(`${API_BASE}/api/clubs/${clubId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return handleResponse(response, 'Unable to delete club.');
};

export const fetchClubOfficials = async (clubId, token) => {
  const response = await fetch(`${API_BASE}/api/clubs/${clubId}/officials`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return handleResponse(response, 'Unable to load club officials.');
};


export const archiveClub = async (clubId, token) => {
  const response = await fetch(`${API_BASE}/api/super-admin/clubs/${clubId}/archive`, {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return handleResponse(response, 'Unable to archive club.');
};

export const unarchiveClub = async (clubId, token) => {
  const response = await fetch(`${API_BASE}/api/super-admin/clubs/${clubId}/unarchive`, {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return handleResponse(response, 'Unable to unarchive club.');
};
